import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer-tick',
    template: `<em *ngIf="enableTick">
		<img style="cursor:pointer;" 
		src="./assets/images/tick_blue.svg" 
		(click)="btnClickedHandler('tick')">
		</em>`,
    standalone: false
})
export class BtnCellRendererTick implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableTick: boolean = false;
	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//tiersetup
		if (this.params.colDef.field == "fifo") {  // NOSONAR
			if (this.params.data.fifo == '0') {  // NOSONAR
				this.enableTick = false;
			}
			else if (this.params.data.fifo == '1') {  // NOSONAR
				this.enableTick = true;
			}
		}
		if (this.params.colDef.field == "unloadBased") {  // NOSONAR
			if (this.params.data.unloadBased == "0") {  // NOSONAR
				this.enableTick = false;
			}
			else if (this.params.data.unloadBased == '1') {  // NOSONAR
				this.enableTick = true;
			}
		}

	}

	btnClickedHandler(action) {
		if (action == 'tick') {  // NOSONAR
			this.params.context.componentParent.tickChecked(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
console.info()
 }
}
